export default {
  env: 'local',
  kibanaApi: 'https://api-support-test.xfinity.com/logger/',
};
